import React from 'react';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import MultiSelector from '../../UI/MultiSelector/MultiSelector';

// Models
import { Pathology } from '../../../interfaces/Preconfigurations';
import { PreconfigDataDispatch } from '../../../hooks/preconfig-hooks';
interface Props {
    pathologies: Pathology[]
    selectedPathologiesIDs: number[]
    dispatchPreconfig: React.Dispatch<PreconfigDataDispatch>
}

const MultiSelectPathologies: React.FC<Props> = ({
    pathologies,
    selectedPathologiesIDs,
    dispatchPreconfig,
}) => {

    const { t } = useTranslation();

    const handleChangePathologies = (id: number | string) => {
        if (id === -1) dispatchPreconfig({
            type: 'SET_PATHOLOGIES',
            payload: selectedPathologiesIDs.length === pathologies.length ? [] : pathologies.map(p => p.id)
        })
        else dispatchPreconfig({ type: 'ADD_PATHOLOGY', payload: Number(id) });
    };

    const pathologiesOptions = pathologies.map(pathology => ({
        ...pathology,
        checked: selectedPathologiesIDs.some(selectedPathologyID => selectedPathologyID === pathology.id)
    }));
    return (
        <MultiSelector
            label={t('add_tags') as string}
            options={pathologiesOptions}
            handleChange={handleChangePathologies}
        />
    );
};

export default MultiSelectPathologies;